/* eslint-disable */
export default {
  // Auth
  HOME: '/',
  LOGIN: '/login',
  FORGOT_PASSWORD: '/recuperar-senha',
  RESET_PASSWORD: '/resetar-senha',

  // Module
  SELECT_MODULE: '/selecione-um-modulo',

  // Workspace
  SELECT_WORKSPACE: {
    MODULE: '',
    BASE_URL: '/bdos/selecione-um-workspace',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
    get CREATE_CONSORTIUM() {
      return this.BASE_URL + '/consorcio';
    },
  },

  // Passengers
  PASSENGER: {
    MODULE: 'USER',
    BASE_URL: '/bdos/passageiros',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
    get EDIT() {
      return this.BASE_URL + '/editar/:id';
    },
  },

  // Companies
  COMPANIES: {
    MODULE: 'COMPANY',
    BASE_URL: '/bdos/empresas',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
    get EDIT() {
      return this.BASE_URL + '/editar/:id';
    },
    get CREATE_COLLABORATOR() {
      return this.BASE_URL + '/editar/:id/collaborator/criar';
    },
  },

  // Ticketing
  TICKETING: {
    MODULE: '',
    BASE_URL: '/bdos/bilhetagem',
  },

  // Stops
  STOPS: {
    MODULE: 'STOP',
    BASE_URL: '/bdos/pontos',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
    get EDIT() {
      return this.BASE_URL + '/editar/:id';
    },
    get CHART() {
      return this.BASE_URL + '/charts/:id';
    },
  },

  // Sections
  SECTIONS: {
    MODULE: 'SECTION',
    BASE_URL: '/bdos/secoes',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
    get EDIT() {
      return this.BASE_URL + '/editar/:id';
    },
  },

  // Garage
  GARAGE: {
    MODULE: 'GARAGE',
    BASE_URL: '/bdos/gestao-de-garagens',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
    get EDIT() {
      return this.BASE_URL + '/editar/:id';
    },
  },

  // Changes by period
  CHANGES_BY_PERIOD: {
    MODULE: 'CHANGES_BY_PERIOD',
    BASE_URL: '/bdos/alteracoes-por-periodo',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
    get EDIT() {
      return this.BASE_URL + '/editar/:id';
    },
  },

  // Boarding Fares
  BOARDING_FARES: {
    MODULE: 'BOARDING_FARES',
    BASE_URL: '/bdos/taxas-de-embarque',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
    get EDIT() {
      return this.BASE_URL + '/editar/:id';
    },
  },

  // Terminal Management
  TERMINAL_MANAGEMENT: {
    MODULE: 'TERMINAL',
    BASE_URL: '/bdos/gestao-de-terminais',

    get CREATE() {
      return this.BASE_URL + '/criar';
    },
    get EDIT() {
      return this.BASE_URL + '/editar/:id';
    },
  },

  // Terminal Blocks
  TERMINAL_BLOCKS: {
    MODULE: '',
    BASE_URL: '/bdos/bloqueios-de-terminais',
  },

  // Changelog history
  CHANGELOG_HISTORY: {
    MODULE: '',
    BASE_URL: '/bdos/historico-de-changelogs',
  },

  // Employee Trip Sap Resume Report
  EMPLOYEE_TRIP_SAP_RESUME_REPORT: {
    MODULE: 'EMPLOYEE_TRIP_SAP_RESUME_REPORT',
    BASE_URL: '/bdos/relatorios/relatorio-resumido-de-viagens-de-motoristas',
  },

  // External Reports
  EXTERNAL_REPORTS: {
    MODULE: '',
    BASE_URL: '/bdos/relatorios-exclusivos',
  },

  // Asynchronous Reports
  ASYNCHRONOUS_REPORTS: {
    MODULE: 'EXCLUSIVE_REPORTS_MODULE',
    BASE_URL: '/bdos/relatorios/relatorios-assincronos',
  },

  // Tolls
  TOLLS: {
    MODULE: 'TOLL',
    BASE_URL: '/bdos/pedagios',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
    get EDIT() {
      return this.BASE_URL + '/editar/:id';
    },
  },

  // Integration Fence
  INTEGRATION_FENCE: {
    MODULE: 'INTEGRATION_FENCE',
    BASE_URL: '/bdos/cercas-de-integracao',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
    get EDIT() {
      return this.BASE_URL + '/editar/:id';
    },
  },

  // Lines
  LINES: {
    MODULE: 'LINE',
    BASE_URL: '/bdos/linhas',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
    get EDIT() {
      return this.BASE_URL + '/editar/:id';
    },
    get LINEADDWAY() {
      return this.BASE_URL + '/bdos/linhas/adicionar-sentido-oposto/:id';
    },
  },

  // Itineraries
  ITINERARIES: {
    MODULE: '',
    BASE_URL: '/bdos/itinerarios',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
    get EDIT() {
      return this.BASE_URL + '/editar/:id';
    },
    get ITINERARIES_LINE() {
      return this.BASE_URL + '/linha/:id';
    },
  },

  // Schedules Matrix
  SCHEDULES_MATRIX: {
    MODULE: 'SCHEDULES_MATRIX',
    BASE_URL: '/bdos/matriz-de-escalas',
  },

  // Schedules
  SCHEDULES: {
    MODULE: 'SCHEDULES',
    BASE_URL: '/bdos/escalas',
  },

  // Fares
  FARES: {
    MODULE: 'FARE',
    BASE_URL: '/bdos/tarifas',
  },

  // Turnstiles
  TURNSTILES: {
    MODULE: 'TURNSTILES',
    BASE_URL: '/bdos/catracas',
  },

  // Fares
  PRODUCTS: {
    MODULE: 'PRODUCTS',
    BASE_URL: '/bdos/produtos',
  },

  // Profiles
  PROFILES: {
    MODULE: 'PROFILE',
    BASE_URL: '/bdos/bilhetagem/perfis',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
    get EDIT() {
      return this.BASE_URL + '/editar/:id';
    },
  },

  // Lots
  LOTS: {
    MODULE: 'LOT',
    BASE_URL: '/bdos/lotes',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
    get EDIT() {
      return this.BASE_URL + '/editar/:id';
    },
  },

  // Fleet
  FLEET: {
    MODULE: 'CAR',
    BASE_URL: '/bdos/frota',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
    get EDIT() {
      return this.BASE_URL + '/editar/:id';
    },
  },

  // Dbds
  DBDS: {
    MODULE: 'DBD',
    BASE_URL: '/bdos/dbds',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
    get EDIT() {
      return this.BASE_URL + '/editar/:id';
    },
  },

  // Sales network
  SALES_NETWORK: {
    MODULE: 'SELLING_TERMINAL',
    BASE_URL: '/bdos/redes-de-venda',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
    get EDIT() {
      return this.BASE_URL + '/editar/:id';
    },
    get REAL_TIME_CASHIER() {
      return this.BASE_URL + '/caixa-em-tempo-real/:id';
    },
    get ADDMODSUP() {
      return this.BASE_URL + '/editar/:terminalId/pontos-de-venda/criar';
    },
    get EDITMODSUP() {
      return (
        this.BASE_URL + '/editar/:terminalId/pontos-de-venda/editar/:pointId'
      );
    },
  },

  // Sales Network Machine Management
  SALES_NETWORK_MACHINE_MANAGEMENT: {
    MODULE: 'SELLING_TERMINAL',
    BASE_URL: '/bdos/rede-de-venda-gestao-de-maquinas',
  },

  // Selling Terminals
  SELLING_TERMINALS: {
    MODULE: 'SELLING_TERMINAL',
    BASE_URL: '/bdos/arrecadacao/redes-de-venda',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
    get EDIT() {
      return this.BASE_URL + '/editar/:id';
    },
    get ADDMODSUP() {
      return this.BASE_URL + '/editar/:terminalId/pontos-de-venda/criar';
    },
    get EDITMODSUP() {
      return (
        this.BASE_URL + '/editar/:terminalId/pontos-de-venda/editar/:pointId'
      );
    },
  },

  // Onboard Sales
  ONBOARD_SALES: {
    MODULE: 'SELLING_TERMINAL',
    BASE_URL: '/bdos/arrecadacao/vendas-a-bordo',
  },

  // Transport Vouchers
  TRANSPORT_VOUCHER: {
    MODULE: 'SELLING_TERMINAL',
    BASE_URL: '/bdos/arrecadacao/vale-transporte',
  },

  // Collection Instituition
  COLLECTION_INSTITUITION: {
    MODULE: 'SELLING_TERMINAL',
    BASE_URL: '/bdos/arrecadacao/instituicao-de-ensino',
  },

  // Collection Passenger
  COLLECTION_PASSENGER: {
    MODULE: 'SELLING_TERMINAL',
    BASE_URL: '/bdos/arrecadacao/passageiros',
  },

  // Invoices
  INVOICES_MODULE: {
    MODULE: 'INVOICES_MODULE',
    BASE_URL: '/bdos/arrecadacao/notas-fiscais',
  },

  // Drivers
  DRIVERS: {
    MODULE: 'EMPLOYEE',
    BASE_URL: '/bdos/equipe/motoristas',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
    get EDIT() {
      return this.BASE_URL + '/editar/:id';
    },
  },

  // Ticket Collectors
  TICKET_COLLECTORS: {
    MODULE: 'EMPLOYEE',
    BASE_URL: '/bdos/equipe/cobradores',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
    get EDIT() {
      return this.BASE_URL + '/editar/:id';
    },
  },

  // In charge
  IN_CHARGE: {
    MODULE: 'EMPLOYEE',
    BASE_URL: '/bdos/equipe/encarregados',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
    get EDIT() {
      return this.BASE_URL + '/editar/:id';
    },
  },

  // Machine Management
  MACHINE_MANAGEMENT: {
    MODULE: 'EMPLOYEE',
    BASE_URL: '/bdos/equipe/gestao-de-maquinas',
  },

  // BugReports
  BUG_REPORTS: {
    MODULE: 'SYSTEM',
    BASE_URL: '/bdos/ajustes',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
    get EDIT() {
      return this.BASE_URL + '/editar/:id';
    },
  },

  // Relacionamentos
  RELATIONS: {
    MODULE: 'RELATION',
    BASE_URL: '/bdos/relacionamento',
  },

  // Notificações
  NOTIFICATIONS: {
    MODULE: 'NOTIFICATION',
    BASE_URL: '/bdos/relacionamento/notificacoes',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
    get EDIT() {
      return this.BASE_URL + '/editar/:id';
    },
  },

  // Segmentações
  SEGMENTATIONS: {
    MODULE: 'SEGMENTATION',
    BASE_URL: '/bdos/relacionamento/segmentacoes',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
    get EDIT() {
      return this.BASE_URL + '/editar/:id';
    },
  },

  // Facial Recognition
  FACIAL_RECOGNITION: {
    MODULE: 'FACIAL',
    BASE_URL: '/bdos/reconhecimento-facial',
  },

  // Registration Validation
  REGISTRATION_VALIDATION: {
    MODULE: '',
    BASE_URL: '/bdos/validacao-cadastral',
  },

  // Liberação de Dispositivo
  DEVICE_RELEASE: {
    MODULE: '',
    BASE_URL: '/bdos/liberacao-de-dispositivo',
    get FROM_PASSENGER() {
      return this.BASE_URL + '/:id';
    },
  },

  // Inspeção de Embarques
  BOARDING_INSPECTION: {
    MODULE: '',
    BASE_URL: '/bdos/inspecao-de-embarques',
  },

  // Table Entry Report
  TABLE_ENTRY_REPORT: {
    MODULE: 'REPORT_ENTRIES',
    BASE_URL: '/bdos/relatorios/relatorio-de-entrada',
  },

  // Table Entry Report
  KM_PER_DAY_PER_CAR_REPORT: {
    MODULE: 'KM_PER_DAY_PER_CAR_REPORT',
    BASE_URL: '/bdos/relatorios/relatorio-km-por-dia-por-carro',
  },

  // Superior Usage Report
  REPORT_SUPERIOR_ACCESS: {
    MODULE: 'REPORT_SUPERIOR_ACCESS',
    BASE_URL: '/bdos/relatorios/relatorio-de-uso-superior',
  },

  // Chart Value Report
  CHART_VALUE_REPORT: {
    MODULE: 'REPORT_VALUE',
    BASE_URL: '/bdos/relatorios/relatorio-de-valor',
  },

  // Shipment By Line
  SHIPMENT_BY_LINE_REPORT: {
    MODULE: 'SHIPMENT_BY_LINE',
    BASE_URL: '/bdos/relatorios/relatorio-de-embarque-por-linha',
    get LINE_ID() {
      return this.BASE_URL + '/:id';
    },
  },

  // Line Demand Report
  LINE_DEMAND_REPORT: {
    MODULE: 'REPORT_DEMAND_BY_LINE',
    BASE_URL: '/bdos/relatorios/demanda-por-linha',
  },

  // Line Quantity Report
  LINE_QUANTITY_REPORT: {
    MODULE: 'REPORT_DEMAND_BY_LINE_QUANTITY',
    BASE_URL: '/bdos/relatorios/quantidade-por-linha',
  },

  // Car Demand Report
  CAR_QUANTITY_REPORT: {
    MODULE: 'REPORT_DEMAND_BY_CAR_QUANTITY',
    BASE_URL: '/bdos/relatorios/relatorio-de-quantidade-por-carro',
  },

  // Trecho Demand Report
  SEGMENT_DEMAND_REPORT: {
    MODULE: 'SEGMENT_DEMAND_REPORT',
    BASE_URL: '/bdos/relatorios/demanda-por-trecho',
  },

  // Trecho Quantity Report
  SEGMENT_QUANTITY_REPORT: {
    MODULE: 'SEGMENT_DEMAND_REPORT_QUANTITY',
    BASE_URL: '/bdos/relatorios/quantidade-por-trecho',
  },

  // Line Demand Report
  DAILY_DEMAND_REPORT: {
    MODULE: 'REPORT_DEMAND_BY_DAILY',
    BASE_URL: '/bdos/relatorios/demanda-por-dia',
  },

  // Line Demand Report
  DAILY_QUANTITY_REPORT: {
    MODULE: 'REPORT_DEMAND_BY_DAILY_QUANTITY',
    BASE_URL: '/bdos/relatorios/quantidade-por-dia',
  },

  // Shipment Distribution
  SHIPMENT_DISTRIBUTION: {
    MODULE: 'REPORT_LOCALIZATION',
    BASE_URL: '/bdos/relatorios/relatorio-de-embarque',
  },

  // Passengers and vehicles
  PASSENGERS_AND_VEHICLES: {
    MODULE: 'PASSENGERS_AND_VEHICLES_REPORT',
    BASE_URL: '/bdos/relatorios/relatorio-de-passageiros-e-veiculos',
  },

  // Passengers and vehicles by trip
  PASSENGERS_AND_VEHICLES_BY_TRIP: {
    MODULE: 'PASSENGERS_AND_VEHICLES_BY_TRIP_REPORT',
    BASE_URL: '/bdos/relatorios/relatorio-de-passageiros-e-veiculos-por-viagem',
  },

  // Passengers and vehicles by trip
  PASSENGERS_BY_TERMINAL: {
    MODULE: 'PASSENGERS_BY_TERMINAL',
    BASE_URL: '/bdos/relatorios/relatorio-de-passageiros-por-terminal',
  },

  // Half Trip Diary
  HALF_TRIP_DIARY: {
    MODULE: 'REPORT_HALF_TRIP',
    BASE_URL: '/bdos/relatorios/diario-de-meia-viagem',
  },

  // Credit By College
  CREDITS_BY_COLLEGE: {
    MODULE: 'REPORT_HALF_TRIP',
    BASE_URL: '/bdos/relatorios/credito-por-coleta',
  },

  // Collection Report
  COLLECTION_REPORT: {
    MODULE: 'REPORT_SALES_NETWORK',
    BASE_URL: '/bdos/relatorios/relatorio-de-arrecadacao',
  },

  // Receipts Report
  RECEIPTS_REPORT: {
    MODULE: 'REPORT_RECEIPT',
    BASE_URL: '/bdos/relatorios/relatorio-de-recebimentos',
  },

  // Receipts Payment Request
  PAYMENT_REQUEST_REPORT: {
    MODULE: 'REPORT_PAYMENT_REQUEST',
    BASE_URL: '/bdos/relatorios/relatorio-de-requisicao-pagamento',
  },

  // Collection Consolidation
  COLLECTION_CONSOLIDATION_REPORT: {
    MODULE: 'REPORT_INCOMING_CONSOLIDATION',
    BASE_URL: '/bdos/relatorios/relatorio-de-consolidacao-de-arrecadacao',
  },

  // Ticket Average Report
  TICKET_AVERAGE_REPORT: {
    MODULE: 'TICKET_AVERAGE',
    BASE_URL: '/bdos/relatorios/relatorio-de-captacao',
  },

  // Ticket Average Report
  EMV_REPORT: {
    MODULE: 'EMV_REPORT',
    BASE_URL: '/bdos/relatorios/relatorio-de-emv',
  },

  // Ticket Average Report
  EMV_REPORT_OCURRENCES: {
    MODULE: 'EMV_REPORT_OCURRENCES',
    BASE_URL: '/bdos/relatorios/relatorio-de-ocorrencias-emv',
  },

  // School Order Detail Reprot
  SCHOOL_ORDER_REPORT: {
    MODULE: 'SCHOOL_ORDER_REPORT',
    BASE_URL: '/bdos/relatorios/relatorio-consolidado-de-pedidos-por-escola',
  },

  BPE_REPORT: {
    MODULE: 'BPE_REPORT',
    BASE_URL: '/bdos/relatorios/bilhete-electronico',
  },
  BPE_TAX_VERIFICATION_REPORT: {
    MODULE: 'BPE_TAX_VERIFICATION_REPORT',
    BASE_URL: '/bdos/relatorios/bilhete-electronico-verificacao-do-icms',
  },

  // Student Device Report
  REPORT_STUDENTS_DEVICE: {
    MODULE: 'REPORT_STUDENTS_DEVICE',
    BASE_URL: '/bdos/relatorios/relatorio-de-cartoes-por-aluno',
  },

  // Onboard Sales Report
  ONBOARD_SALES_REPORT: {
    MODULE: 'REPORT_ONBOARD_SALES',
    BASE_URL: '/bdos/relatorios/relatorio-de-venda-a-bordo',
  },

  // Transport Voucher Collection Report
  TRANSPORT_VOUCHER_COLLECTION_REPORT: {
    MODULE: 'REPORT_VT_AND_USERS',
    BASE_URL: '/bdos/relatorios/relatorio-de-arrecadacao-de-vale-transporte',
  },

  // Operator Commission Report
  OPERATOR_COMMISSION_REPORT: {
    MODULE: 'REPORT_OPERATORS_COMMITTEE',
    BASE_URL: '/bdos/relatorios/relatorio-de-comissao-de-operadores',
  },

  // Car Demand Report
  CAR_DEMAND_REPORT: {
    MODULE: 'REPORT_DEMAND_BY_CAR',
    BASE_URL: '/bdos/relatorios/relatorio-de-demanda-por-carro',
  },

  // Company Acquisitions Report
  COMPANY_ACQUISITIONS_REPORT: {
    MODULE: 'REPORT_PURCHASE',
    BASE_URL: '/bdos/relatorios/relatorio-de-compras-por-empresa',
  },

  // Transported Passengers Report
  TRANSPORTED_PASSENGERS_REPORT: {
    MODULE: 'REPORT_TRANSPORTED_PASSENGERS',
    BASE_URL: '/bdos/relatorios/relatorio-de-passageiros-transportados',
  },

  // KM DRIVED REPORT
  KM_DRIVED_REPORT: {
    MODULE: 'REPORT_KM_DRIVED',
    BASE_URL: '/bdos/relatorios/relatorio-de-km-rodados',
  },

  // CREDIT USAGE BY INSTITUTION
  CREDIT_USAGE_BY_INSTITUTION_REPORT: {
    MODULE: 'REPORT_CREDIT_USAGE_BY_INSTITUTION',
    BASE_URL:
      '/bdos/relatorios/relatorio-de-utilização-de-créditos-por-instituição',
  },

  // PASSENGERS BY TIME FRAME
  PASSENGERS_BY_TIME_FRAME_REPORT: {
    MODULE: 'REPORT_PASSENGERS_BY_TIME_FRAME',
    BASE_URL: '/bdos/relatorios/relatorio-de-passageiros-por-faixa-horária',
  },
  // PASSENGERS BY TIME FRAME
  EMPLOYEE_TRIP_RESUME_REPORT: {
    MODULE: 'EMPLOYEE_TRIP_RESUME_REPORT',
    BASE_URL: '/bdos/relatorios/relatorio-resumo-de-viagems',
  },

  // PASSENGERS BY ORIGIN
  PASSENGERS_TRANSPORTED_BY_ORIGIN_REPORT: {
    MODULE: 'PASSENGERS_TRANSPORTED_BY_ORIGIN_REPORT',
    BASE_URL:
      '/bdos/relatorios/relatorio-de-passageiros-transportados-por-origem',
  },

  // PASSENGERS BY TIME FRAME BY PROFILE
  PASSENGERS_BY_TIME_FRAME_BY_PROFILE_REPORT: {
    MODULE: 'REPORT_PASSENGERS_BY_TIME_FRAME_BY_PROFILE',
    BASE_URL:
      '/bdos/relatorios/relatorio-de-passageiros-por-faixa-horária-por-perfil',
  },

  // Company Acquisitions Report
  COMPANY_IMPORTATIONS_REPORT: {
    MODULE: 'REPORT_IMPORTATIONS',
    BASE_URL: '/bdos/relatorios/relatorio-de-importacoes',
  },

  // Emtu Report
  EMTU_REPORT: {
    MODULE: 'REPORT_BALANCE',
    BASE_URL: '/bdos/relatorios/relatorio-emtu',
  },

  // Gratuities Report
  GRATUITIES_REPORT: {
    MODULE: 'REPORT_BALANCE',
    BASE_URL: '/bdos/relatorios/relatorio-gratuidades',
  },

  // General Report
  GENERAL_REPORT: {
    MODULE: 'REPORT_PASSENGERS_CARRIED',
    BASE_URL: '/bdos/relatorios/relatorio-geral',
  },

  // Travel By Line Report
  TRAVEL_BY_LINE_REPORT: {
    MODULE: 'REPORT_TRIPS_BY_LINE',
    BASE_URL: '/bdos/relatorios/viagems-por-linha',
  },

  // Live Monitoring
  LIVE_MONITORING: {
    MODULE: '',
    BASE_URL: '/bdos/monitoramento-ao-vivo',
  },

  // Trip Monitoring
  TRIP_MONITORING: {
    MODULE: '',
    BASE_URL: '/bdos/monitoramento-de-viagens',
  },

  // Variable Message board
  VARIABLE_MESSAGE_BOARD: {
    MODULE: '',
    BASE_URL: '/bdos/painel-de-mensagem-variavel',
  },

  VARIABLE_MESSAGE_BOARD_PUBLIC: {
    MODULE: '',
    BASE_URL: '/painel-de-mensagem-variavel',

    get BUS() {
      return this.BASE_URL + '/onibus/:transportOperatorId/:lineQuantity/:id';
    },
    get METRO() {
      return (
        this.BASE_URL +
        '/metro/:transportOperatorId/:color/:name/:prefix/:ways/:currLineId/:id'
      );
    },
    get VESSELS() {
      return (
        this.BASE_URL +
        '/balsa/:switchLine/:lineQuantity/:id/:transportOperatorId'
      );
    },
    get METRO_LOTACAO() {
      return this.BASE_URL + '/metro/lotacao/:stopId';
    },
  },

  // Km Record
  KM_RECORD: {
    MODULE: '',
    BASE_URL: '/bdos/registro-de-km',
  },

  // Fiscalization
  FISCALIZATION: {
    MODULE: '',
    BASE_URL: '/bdos/fiscalizacao',
  },

  // Invoices
  INVOICES: {
    MODULE: '',
    BASE_URL: '/bdos/faturas',
  },

  // Applications
  APPLICATIONS: {
    MODULE: '',
    BASE_URL: '/bdos/aplicativos',
  },

  // Company Management
  COMPANY_MANAGEMENT: {
    MODULE: '',
    BASE_URL: '/bdos/gerenciar-empresa',

    get CREATE_GROUP() {
      return this.BASE_URL + '/grupos/criar';
    },
    get MANAGEMENT_MODULES() {
      return this.BASE_URL + '/modulos/:id';
    },

    get MODULES_MANAGEMENT() {
      return this.BASE_URL + '/gerenciar-modulos/:id';
    },
  },

  // System Management
  SYSTEM_MANAGEMENT: {
    MODULE: '',
    BASE_URL: '/bdos/gerenciar-sistema',
    get CREATE_GROUP() {
      return this.BASE_URL + '/grupos/criar';
    },
  },

  // Benefits
  BENEFITS: {
    MODULE: '',
    BASE_URL: '/regras-de-negocios/politicas-tarifarias',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
    get EDIT() {
      return this.BASE_URL + '/editar/:id';
    },
  },

  // Transport Cards
  TRANSPORT_CARDS: {
    MODULE: 'TRANSPORT_CARD',
    BASE_URL: '/bdos/cartoes-de-transporte',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
    get EDIT() {
      return this.BASE_URL + '/editar/:id';
    },

    get CREATE_LOCAL() {
      return this.BASE_URL + '/local/criar';
    },
    get EDIT_LOCAL() {
      return this.BASE_URL + '/local/editar/:id';
    },
  },

  // Integrações
  LINE_MATRIX: {
    MODULE: '',
    BASE_URL: '/bdos/bilhetagem/integracoes',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
  },

  // Gestão de estações
  METRO_STATION_MANAGEMENT: {
    MODULE: '',
    BASE_URL: '/bdos/bilhetagem/gestao-de-estacoes',
  },

  // Materiais Impressos
  PRINT_MODEL: {
    MODULE: 'PRINT_MODEL',
    BASE_URL: '/bdos/bilhetagem/materiais-impressos',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
    get EDIT() {
      return this.BASE_URL + '/editar/:id';
    },
  },

  // Schools
  SCHOOLS: {
    MODULE: 'SCHOOL',
    BASE_URL: '/bdos/instituicoes-de-ensino',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
    get EDIT() {
      return this.BASE_URL + '/editar/:id';
    },
  },

  // Template
  TEMPLATE: {
    MODULE: '',
    BASE_URL: '/bdos/template',
  },

  // Attendance
  ATTENDANCE: {
    MODULE: 'ATTENDANCE',
    BASE_URL: '/atendimento',
    get CONFIGURATIONS() {
      return this.BASE_URL + '/configuracoes';
    },
    get REPORTS() {
      return this.BASE_URL + '/relatorios';
    },
    get CREATE_TAGS() {
      return this.BASE_URL + '/tags/criar';
    },
    get CREATE_REPLY() {
      return this.BASE_URL + '/respostas/criar';
    },
    get CREATE_ATTENDANTS() {
      return this.BASE_URL + '/atendentes/criar';
    },
    get CREATE_WEBHOOK() {
      return this.BASE_URL + '/webhook/criar';
    },
  },

  // Company
  COMPANY_MODULE: {
    MODULE: 'COMPANY',
    BASE_URL: '/empresas',
    get LOGIN() {
      return this.BASE_URL + '/login';
    },
    get FORGOT_PASSWORD() {
      return this.BASE_URL + '/recuperar-senha';
    },
    get EDIT() {
      return this.BASE_URL + '/editar/:id';
    },
  },

  // Company Collaborators
  COMPANY_COLLABORATORS: {
    MODULE: '',
    BASE_URL: '/empresas/colaboradores',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
  },

  // Company Group
  COMPANY_GROUP: {
    MODULE: '',
    BASE_URL: '/empresas/grupos',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
  },

  // Company Orders
  COMPANY_ORDERS: {
    MODULE: '',
    BASE_URL: '/empresas/pedidos',
    DUPLICATE_ORDER: '/empresas/pedidos/:id',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
  },

  // Account Settings
  ACCOUNT_SETTINGS_MODULE: {
    MODULE: '',
    BASE_URL: '/configuracoes-da-conta',
  },

  // Company Orders History
  COMPANY_ORDERS_HISTORY: {
    MODULE: '',
    BASE_URL: '/empresas/pedidos/historico',
  },

  // Company Invoices
  COMPANY_INVOICES: {
    MODULE: '',
    BASE_URL: '/empresas/faturas',
  },

  // Teaching Institution Module
  TEACHING_INSTITUTION_MODULE: {
    MODULE: '',
    BASE_URL: '/instituicoes-de-ensino',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
    get EDIT() {
      return this.BASE_URL + '/editar/:id';
    },
  },

  // Teaching Institution Students
  TEACHING_INSTITUTION_STUDENTS: {
    MODULE: '',
    BASE_URL: '/instituicoes-de-ensino/estudantes',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
  },

  // Teaching Institution Orders
  TEACHING_INSTITUTION_ORDERS: {
    MODULE: '',
    BASE_URL: '/instituicoes-de-ensino/pedidos',
  },

  // Teaching Institution Orders History
  TEACHING_INSTITUTION_ORDERS_HISTORY: {
    MODULE: '',
    BASE_URL: '/instituicoes-de-ensino/historico',
  },

  // My Selling Terminal
  SELLING_TERMINAL: {
    MODULE: '',
    BASE_URL: '/redes-de-venda/minha-rede-de-venda',
  },

  // Selling Points
  SELLING_POINTS: {
    MODULE: '',
    BASE_URL: '/redes-de-venda/pontos-de-venda',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
    get EDIT() {
      return this.BASE_URL + '/editar/:id';
    },
  },
  SELLING_TERMINAL_DETAILS: {
    MODULE: '',
    BASE_URL: '/redes-de-venda/rede-de-venda',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
    get EDIT() {
      return this.BASE_URL + '/editar/:id';
    },
  },

  // My Selling Terminal
  NOT_ALLOWED: {
    MODULE: '',
    BASE_URL: '/bdos/nao-autorizado',
  },
  // Connectivity
  DATA_PLAN_CONNECTIVITY: {
    MODULE: '',
    BASE_URL: '/bdos/conectividade/plano-de-dados',
  },
  CONECTION_COVER_CONNECTIVITY: {
    MODULE: '',
    BASE_URL: '/bdos/conectividade/cobertura-de-conexao',
  },
  WIFI_ROUTING_CONNECTIVITY: {
    MODULE: '',
    BASE_URL: '/bdos/conectividade/roteamento-de-wifi',
  },

  // Usage Statistics Report
  USAGE_STATISTICS: {
    MODULE: '',
    BASE_URL: '/bdos/relatorios/estatistica-de-utilizacao',
  },

  // PASSENGERS BY ORIGIN
  PROFILE_BY_AGE_GROUP_REPORT: {
    MODULE: 'PROFILE_BY_AGE_GROUP_REPORT',
    BASE_URL: '/bdos/relatorios/relatorio-de-perfil-por-faixa-etaria',
  },

  // Vesseles
  VESSELS: {
    MODULE: 'VESSELES',
    BASE_URL: '/bdos/embarcacoes',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
    get EDIT() {
      return this.BASE_URL + '/editar/:id';
    },
  },

  // Plantas
  PLANTAS: {
    MODULE: 'CAR',
    BASE_URL: '/bdos/plantas',
    get CREATE() {
      return this.BASE_URL + '/criar';
    },
    get EDIT() {
      return this.BASE_URL + '/editar/:id';
    },
  },

  // Vesseles
  TICKET_RESERVATION_WEBSITE: {
    MODULE: '',
    BASE_URL: '/venda-de-passagens',
    get TICKET_DETAILS() {
      return this.BASE_URL + '/detalhes-da-passagens';
    },
    get LOGIN() {
      return this.BASE_URL + '/entrar';
    },
    get TO_PAY() {
      return this.BASE_URL + '/pagar';
    },
    get MY_ORDERS() {
      return this.BASE_URL + '/pedidos';
    },
    get MY_BPE() {
      return this.BASE_URL + '/bpe';
    },
    get PROFILE() {
      return this.BASE_URL + '/perfil';
    },
  },

  MANUAL_URL: {
    MODULE: '',
    BASE_URL: 'https://centraldeajuda.onboardmobility.com/empresas',
  },
  // GetNetWebView
  GET_NET_WEB_VIEW: {
    MODULE: '',
    BASE_URL: '/',
    get ALL_PARAMS() {
      return (
        this.BASE_URL +
        'getnetwebview/:amount/:customerid/:cpf/:name/:email/:cep/:street/:number/:complement/:neighborhood/:city/:state'
      );
    },
    get PARAMS() {
      return (
        this.BASE_URL + 'getnetwebview/:amount/:customerid/:cpf/:name/:email'
      );
    },
  },
};
